import React from 'react';
import tour1 from '../../images/project/tour1.PNG'
import tour2 from '../../images/project/tour2.PNG'
import tour3 from '../../images/project/tour3.PNG'


const Project2 = () => {
    return (
        <div>
            <div>
                <h2 className="mt-4 mb-2"> Project Details</h2>
                <p class="card-text">● Authentication system added (user & admin) <br />
                    ● Users can book any kind of tourist place <br />
                    ● React, React Router, Firebase, Bootstrap, MongoDB, Express were used for this site</p>
            </div>
            <div>
                <div>
                    <h2 className="mt-4 mb-3">Project Screenshots</h2>
                </div>
                <div className="row" >
                    <div class="card-group">
                        <div class="card">
                            <img src={tour1} class="img-thumbnail" alt="..." />
                            <div class="card-body">
                                <h5 class="card-title">HOME PAGE SECTION</h5>

                            </div>

                        </div>
                        <div class="card">
                            <img src={tour2} class="img-thumbnail" alt="..." />
                            <div class="card-body">
                                <h5 class="card-title">TOUR PAGE SECTION</h5>

                            </div>

                        </div>
                        <div class="card">
                            <img src={tour3} class="img-thumbnail" alt="..." />
                            <div class="card-body">
                                <h5 class="card-title">BLOG PAGE SECTION</h5>

                            </div>

                        </div>
                    </div>
                </div>
            </div>
            <div >

                <button type="button" class="btn m-2 btn-success"><a className="text-white" target="_blank" style={{ textDecoration: 'none' }} href="https://cranky-einstein-705d13.netlify.app/" >Live Site</a>
                </button>
                <button type="button" class="btn m-2 btn-danger"><a className="text-white" target="_blank" style={{ textDecoration: 'none' }} href="https://github.com/ahadakash/tourism-site" >Github Code</a>
                </button>


            </div>
        </div>
    );
};

export default Project2;